<template>
  <div ref="plot" class="legend scrollbox bg"></div>
</template>

<script>
import Plotly from 'plotly.js-dist';

export default {
  name: 'PlotlyChart',
  props: {
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    layout: {
      type: Object,
      required: false,
      default: () => {},
    },
    scrollZoom: {
      type: Boolean,
      required: false,
      default: false,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    staticPlot: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayModeBar: {
      type: Boolean,
      required: false,
      default: true,
    },
    responsive: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    data: 'renderChart',
    layout: 'renderChart',
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const config = {
        scrollZoom: this.scrollZoom,
        editable: this.editable,
        staticPlot: this.staticPlot,
        displayModeBar: this.displayModeBar,
        responsive: this.responsive,
        displaylogo: false,
      };
      Plotly.newPlot(this.$refs.plot, this.data, this.layout, config);
    },
  },
};
</script>
